module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_is-object.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_is-object.js
// module chunks = common